import "./Navigation.scss"

import { Link, useSearchParams } from "react-router-dom"

import { UserRole } from "@/entities/user"
import { useAppSelector } from "@/store/hooks"

function Navigation() {
  const user = useAppSelector(state => state.user)
  const [searchParams] = useSearchParams()
  const companyId = searchParams.get("company-id")
  const auditLogPath = `/audit-log${companyId ? `?companyId=${companyId}` : ""}`


  return (
    <nav className="navigation">
      {<Link className="navigation__link" to={"/stream/settings"}>Open STREAM settings</Link>}
      {user.role >= UserRole.StreamManager && <Link className="navigation__link" to={auditLogPath}>Logs</Link>}
    </nav>
  )
}

export default Navigation
